module.exports = __webpack_public_path__ + "static/media/autopilot-mode@3x.dc82d8b3.png";